/// <amd-module name="Search/Code/Constants" />

export namespace PrivewPivotActionIds {
    export const Contents = "contents";
}

export namespace PreviewOrientationActionIds {
    export const Right = "right";
    export const Bottom = "bottom";
}

export namespace CustomerIntelligenceConstants {
    export const QueryResultScenarioName = "CodeSearchQueryResultsScenario";
    export const EntityName = "code";
    export const TTIScenarioName = "CodeSearchTTIScenario";
    export const TabSwitchScenarioName = "CodeSearchTabSwitchScenario";
    export const SubsequentSearchScenarioName = "CodeSearchTTIScenario";
    export const SearchStarted = "SearchStarted";
    export const ResultsLoaded = "ResultsLoaded";
    export const ItemChanged = "ItemChanged";
    export const PreviewOrientationChanged = "PreviewOrientationChanged";
    export const ZeroData = "ZeroData";
    export const NotificationBanner = "NotificationBanner";
    export const SearchInNewTab = "SearchInNewTab";
    export const FetchMoreResultsStarted = "FetchMoreResultsStarted";
    export const SearchTextRemoved = "SearchTextRemoved";
    export const FeedbackLinkClicked = "FeedbackLinkClicked";
    export const FeedbackMailLinkClicked = "FeedbackMailLinkClicked";
    export const DataRefreshInfoClicked = "DataRefreshInfoClicked";
    export const ContextualMenuItemClicked = "ContextualMenuItemClicked";
    export const FileDownloadStarted = "DownloadFileStarted";
    export const LeftPaneFileNameClicked = "LeftPaneFileNameClicked";
    export const LaunchPoint = "LaunchPoint";
    export const LearnMoreOnPartialCodeResultsClicked = "LearnMoreOnPartialCodeResultsClicked";
    export const SortOptionChanged = "SortOptionChanged";
    export const AccountButtonClicked = "AccountButtonClicked";
    export const FiltersUpdated = "FiltersUpdated";
    export const FilterResetClicked = "FilterResetClicked";
    export const PreviewFileNameClicked = "PreviewFileNameClicked";
    export const RefreshInfoData = "DataRefreshInfo";
    export const QueryStalenessInfo = "QueryBranchStalenessInfo";
    export const FetchGitCommit = "FetchGitCommit";
    export const FetchTFVCCommit = "FetchTFVCCommit";
    export const FetchDataRefreshInfo = "FetchDataRefreshInfo";
    export const FetchGitCommitBatch = "FetchGitCommitBatch";
    export const FetchTFVCChangeSets = "FetchTFVCChangeSets";
    export const FetchCustomChangeData = "FetchCustomChangeData";
}

export namespace ItemCommandKeys {
    export const browseFile = "browseFile";
    export const download = "download";
    export const copyPath = "copyPath";
    export const linkToFile = "linkToFile";
}

export namespace FilterKeys {
    export const ProjectFiltersKey: string = "ProjectFilters";
    export const RepositoryFiltersKey: string = "RepositoryFilters";
    export const BranchFiltersKey: string = "BranchFilters";
    export const PathFiltersKey: string = "PathFilters";
    export const CodeTypeFiltersKey: string = "CodeElementFilters";
    export const AccountFilterKey: string = "AccountFilters";
}

export namespace SortActionIds {
    export type sortOrderType = "asc" | "desc";
    export const FilePath = "path";
    export const FileName = "fileName";
    export const Relevance = "relevance";
    export const Ascending: sortOrderType = "asc";
    export const Descending: sortOrderType = "desc";
}

export namespace IndexingErrorCodeConstants {
    export const AccountIsBeingIndexed = "AccountIsBeingIndexed";
    export const AccountIsBeingReindexed = "AccountIsBeingReindexed";
    export const AccountIsBeingOnboarded = "AccountIsBeingOnboarded";
    export const BranchesAreBeingIndexed = "BranchesAreBeingIndexed";
}

export namespace SearchErrorCodeConstants {
    export const PartialResultsDueToSearchRequestTimeout = "PartialResultsDueToSearchRequestTimeout";
}

export namespace PreferenceConstants {
    export const SortOptionKey = "vss-search-web/code/sortOption";
    export const SplitterFixedSizeKey = "vss-search-web/code/splitterFixedSize";
    export const PreviewOrientationKey = "vss-search-web/code/previewOrientation";
}

export namespace FeatureFlagConstants {
    export const ServerSort = "WebAccess.Search.Code.ServerSort";
    export const InfiniteScroll = "WebAccess.Search.Code.InfiniteScroll";
    export const CodeElementAggregations = "WebAccess.Search.Code.DisableCodeElementAggregations";
    export const DisableAggregations: string = "WebAccess.Search.Code.DisableAggregations";
    export const DataRefreshInfo = "WebAccess.Search.Code.DataRefreshInfo";
    export const BranchStalenessBanner = "WebAccess.Search.Code.BranchStalenessBanner";
}

export const ContentHitKey = "content";
export const MaxHitsToHighlight = 100;
export const EntityTypeUrlParam = "code";
export const CodeSearchTakeResults = 50;
export const CodeSearchInfiniteScrollTakeResults = 25;
export const CodeSearchMaxSkipOrTakeResults = 1000;
export const CodeSearchLoadMoreTakeResults = 20;
export const CodexFeedbackMailToLinkFormat =
    "https://developercommunity.visualstudio.com/report?space=21&version=NONE&azActivityId={0}";
export const VersionControlPermissionsBlogLink =
    "https://go.microsoft.com/fwlink/?linkid=2086566";
export const LearnMoreLink = "https://go.microsoft.com/fwlink/?linkid=859315";
export const PartialResultsForCodeBlogLink = "https://go.microsoft.com/fwlink/?linkid=2064617";
export const CodexDevCommunityLink = "https://developercommunity.visualstudio.com/report?space=21";
export const CodeSearchPageDataProviderContributionId = "ms.vss-code-search.code-search-page-viewmodel-data-provider";
export const BranchStalenessThresholdInDays = "Search/Staleness/BranchStalenessBannerThresholdInDays";
export const SDBranchStalenessThresholdInDays = "Search/Staleness/SDBranchStalenessBannerThresholdInDays"